import { Injectable } from '@angular/core';
import { EventBusService } from '@shared/core';
import { Events, NotificationEvent } from '@shared/core/types';
import { PusherService } from '@shared/core/services/pusher.service';

@Injectable({
  providedIn: 'root',
})
export class EventBusListenerService {
  constructor(private readonly eventBus: EventBusService, private readonly pusher: PusherService) {}

  init(): void {
    this.eventBus.on<NotificationEvent>(Events.NotificationEvent).subscribe(event => {
      this.pusher.push(event);
    });
  }
}
